export default "__VITE_ASSET__af172173__"